var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c(
        "div",
        { staticClass: "search-term" },
        [
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchInfo }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "小组名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.groupName,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "groupName", $$v)
                      },
                      expression: "searchInfo.groupName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("查询")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置")
                  ])
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onAdd } },
                    [_vm._v("新增小组")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticStyle: { color: "red" } }, [
        _vm._v(
          "注意：根据微信相关规定，短期关注码不限数量，有效期一个月；长期关注二维码最多只能生成10w个；请谨慎使用！"
        )
      ]),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "tooltip-effect": "dark"
          },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "50" } }),
          _c("el-table-column", {
            attrs: { label: "小组编号", prop: "groupNo" }
          }),
          _c("el-table-column", {
            attrs: { label: "小组名称", prop: "groupName" }
          }),
          _c("el-table-column", {
            attrs: { label: "邀请码类型", prop: "qrcodeType" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.qrcodeType == 1
                      ? _c("span", [_vm._v("短期关注二维码")])
                      : _vm._e(),
                    scope.row.qrcodeType == 2
                      ? _c("span", [_vm._v("长期关注二维码")])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "详情描述", prop: "remark" }
          }),
          _c("el-table-column", {
            attrs: { label: "最后操作人", prop: "sysUserName" }
          }),
          _c("el-table-column", {
            attrs: { label: "更新时间", prop: "UpdatedAt" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.UpdatedAt)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "创建时间", prop: "CreatedAt" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.CreatedAt)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作区", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onView(scope.row)
                          }
                        }
                      },
                      [_vm._v("查看")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onUpdate(scope.row)
                          }
                        }
                      },
                      [_vm._v("变更")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.onDelete(scope.row)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 30, 50, 100],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.viewVisible,
            title: _vm.dialogTitle
          },
          on: {
            "update:visible": function($event) {
              _vm.viewVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-position": "right" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "小组名称:" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.formData.groupName,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "groupName", $$v)
                      },
                      expression: "formData.groupName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "邀请码类型:", prop: "qrcodeType" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      model: {
                        value: _vm.formData.qrcodeType,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "qrcodeType", $$v)
                        },
                        expression: "formData.qrcodeType"
                      }
                    },
                    [
                      _c("el-option", {
                        key: 1,
                        attrs: { label: "短期二维码", value: 1 }
                      }),
                      _c("el-option", {
                        key: 2,
                        attrs: { label: "长期二维码", value: 2 }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "被邀请者赠送：" } },
                        _vm._l(_vm.formData.invitedTicketList, function(
                          item,
                          index
                        ) {
                          return _c(
                            "el-row",
                            { staticClass: "ticket-form-item" },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 10 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "券编号" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: item.ticketRuleNo,
                                          callback: function($$v) {
                                            _vm.$set(item, "ticketRuleNo", $$v)
                                          },
                                          expression: "item.ticketRuleNo"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 10 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "数量" } },
                                    [
                                      _c("el-input-number", {
                                        model: {
                                          value: item.num,
                                          callback: function($$v) {
                                            _vm.$set(item, "num", $$v)
                                          },
                                          expression: "item.num"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "bairun-form-item-label-suffix"
                                        },
                                        [_vm._v("张")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "详情描述:" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.formData.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "remark", $$v)
                      },
                      expression: "formData.remark"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.dialogFormVisible,
            title: _vm.dialogTitle
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-position": "right"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "小组名称:", prop: "groupName" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入" },
                    model: {
                      value: _vm.formData.groupName,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "groupName", $$v)
                      },
                      expression: "formData.groupName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "邀请码类型:", prop: "qrcodeType" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.formData.qrcodeType,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "qrcodeType", $$v)
                        },
                        expression: "formData.qrcodeType"
                      }
                    },
                    [
                      _c("el-option", {
                        key: 1,
                        attrs: { label: "短期二维码", value: 1 }
                      }),
                      _c("el-option", {
                        key: 2,
                        attrs: { label: "长期二维码", value: 2 }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "被邀请者赠送:" } },
                        _vm._l(_vm.formData.invitedTicketList, function(
                          item,
                          index
                        ) {
                          return _c(
                            "el-row",
                            { staticClass: "ticket-form-item" },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "券编号",
                                        prop:
                                          "invitedTicketList." +
                                          index +
                                          ".ticketRuleNo"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          clearable: "",
                                          placeholder: "输入券编号"
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.getTicketDetail(item)
                                          }
                                        },
                                        model: {
                                          value: item.ticketRuleNo,
                                          callback: function($$v) {
                                            _vm.$set(item, "ticketRuleNo", $$v)
                                          },
                                          expression: "item.ticketRuleNo"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "数量",
                                        prop:
                                          "invitedTicketList." + index + ".num"
                                      }
                                    },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          clearable: "",
                                          placeholder: "请输入张数",
                                          min: 1
                                        },
                                        model: {
                                          value: item.num,
                                          callback: function($$v) {
                                            _vm.$set(item, "num", $$v)
                                          },
                                          expression: "item.num"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "bairun-form-item-label-suffix"
                                        },
                                        [_vm._v("张")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c("el-col", { attrs: { span: 2 } }, [
                                _vm._v(" ")
                              ]),
                              _c(
                                "el-col",
                                {
                                  staticClass: "btn-tool-balancrange",
                                  attrs: { span: 2 }
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "btn-tool-balancrange",
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function($event) {
                                              return _vm.onDeleteInvitedTicket(
                                                index
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("-")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                {
                                  staticClass: "btn-tool-balancrange",
                                  attrs: { span: 2 }
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function($event) {
                                              return _vm.onAddInvitedTicket(
                                                index
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("+")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "详情描述:" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入" },
                    model: {
                      value: _vm.formData.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "remark", $$v)
                      },
                      expression: "formData.remark"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.enterDialog } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }